import API from './API';
import BusinessActions from 'actions/BusinessActions';
import URLSearchParams from 'url-search-params';

const BusinessSource = {
  postRemoteBusiness: {
    remote(state) {
      let param = {
          method: 'POST',
          body: JSON.stringify(state.postBusiness),
          headers: API.jsonHeader
      };
      return fetch(API.postBusiness, param).then(res=>res.json());
    },
    shouldFetch(state) {
      return true;
    },
    success: BusinessActions.postBusinessSuccess,
    error: BusinessActions.fetchFailed
  },
  getRemoteBusinessList: {
    remote(state) {
      let sendData = {
        first: state.first,
        maxCount: state.maxCount
      };
      let searchParams = new URLSearchParams();
      for(let k in sendData) {
        if(sendData[k] === 0 || sendData[k]) {
          searchParams.append(k, sendData[k]);
        }
      }
      return fetch(`${API.getBusinessList.replace(':id',state.user_id)}&${searchParams}`).then(res=>res.json()).then(json=>{
        json.updateFnName = 'updateBusinessList';
        return json;
      });
    },
    shouldFetch() {
      return true;
    },
    success: BusinessActions.fetchSuccess,
    error: BusinessActions.fetchFailed
  },
  getRemoteBusiness: {
    remote(state) {
      let url = API.getBusinessDetail.replace(':id', state.id);
      return fetch(url).then(res=>res.json()).then(json=>{
        json.updateFnName = 'updateBusiness';
        return json;
      });
    },
    shouldFetch(state) {
      if(state.id) {
        return true;
      }
    },
    // here we setup some actions to handle our response
    // loading: SearchActions.loadingResults, // (optional)
    success: BusinessActions.fetchSuccess,
    error: BusinessActions.fetchFailed
  },
  getRemoteArticles: {
    remote(state) {
      let url = `${API.getBusinessArticles.replace(':id', state.id)}&first=0&maxCount=60`;
      return fetch(url).then(res=>res.json()).then(json => {
        json.updateFnName = 'updateArticles';
        return json;
      });
    },
    shouldFetch() {
      return true;
    },
    // loading() {},
    success: BusinessActions.fetchSuccess,
    error: BusinessActions.fetchFailed
  }
};

export default BusinessSource;


// WEBPACK FOOTER //
// ./src/sources/BusinessSource.js